import React from 'react';
import CreditosTable from './TableCreditos/TableCreditos';

const Creditos = () => {
  return <CreditosTable/> ;
};

export default Creditos;
